import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconUserPlusSvg } from "./IconUserPlusSvg.mjs";
const IconUserPlus = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconUserPlusSvg, ...iconProps });
};
export {
  IconUserPlus
};
